import { Paper } from '@safedns/skydns-ui-react-lib';

import Loader from '../UI/loader/Loader';
import DomainControllerForm from './DomainControllerForm';
import LocalDomainsForm from './LocalDomainsForm';
import LocalDomainsTable from './LocalDomainsTable';
import DomainControllerTable from './DomainControllerTable';
import Notification from '../UI/notification/Notification';
import styles from './DomainControllers.module.scss';

import {
  useGetUserQuery,
  useGetDomainControllersQuery,
} from '../../services/ADapi';

const DomainControllers = () => {
  const {
    data: { user_id },
  } = useGetUserQuery();

  const { isLoading } = useGetDomainControllersQuery(user_id);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Paper title="Домен контроллер">
        <div className={styles.controllerContainer}>
          <DomainControllerForm />
          <DomainControllerTable />
        </div>
      </Paper>
      <Paper title="Локальные домены">
        <div className={styles.domainsContainer}>
          <LocalDomainsForm />
          <LocalDomainsTable />
        </div>
      </Paper>
      <Notification />
    </>
  );
};


export default DomainControllers;
